var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions.define_ContourLayerGroup = function (in_implements, in_extends, options) {
    var class_definition = OCS.Viewer.Functions.define_layer_group(in_implements, in_extends, options);
    return new Class({
        Extends: class_definition,
        class_name: "ContourLayerGroup",
        style_manager_class: OCS.Viewer.Functions.define_ol_style_manager([new Class(OCS.Viewer.Interfaces.OlLineStyle)])
    });
};

